/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import styles from "./styles";
import { Text } from "@react-pdf/renderer";

const ArtifiPdfPage = (artifiData: any): any => {
  let htmlData: any = [];
  artifiData?.forEach((product: any) => {
    htmlData = [
      ...htmlData,
      <Text key={product?.configurationName} style={styles.productText}>
        {product?.configurationName} (<Text style={styles.designIdColor}>{product?.designId}</Text>)
      </Text>,
      <Text key={product.productName} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Review Design:
        </Text>{" "}
        {product.productName}
      </Text>,
      <Text key={product.sku} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          SKU:
        </Text>{" "}
        {product.sku}
      </Text>,
      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Id:
        </Text>{" "}
        {product.designId}
      </Text>,
      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Name:
        </Text>{" "}
        {product.designName}
      </Text>,
      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Type:
        </Text>{" "}
        {product.designType}
      </Text>,
      <Text key={product.pickStyle} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Pick Style:
        </Text>{" "}
        {product.pickStyle}
      </Text>,
      <Text key={product.selectFabric} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Selected Fabric:
        </Text>{" "}
        {product.selectFabric}
      </Text>,
      <Text key={product.selectDesignTemplate} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Selected Design Template:
        </Text>{" "}
        {product.selectDesignTemplate}
      </Text>,
      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Custom Attributes:
        </Text>
      </Text>,
      // <Text key={""} style={styles.level2Spacing}>
      //   <Text key={""} style={styles.dataKey}>
      //     Body:
      //   </Text>{" "}
      //   {product?.customAttributes.Body}
      // </Text>,
      // <Text key={""} style={styles.level2Spacing}>
      //   <Text key={""} style={styles.dataKey}>
      //     SA:
      //   </Text>{" "}
      //   {product?.customAttributes.SA}
      // </Text>,
      // <Text key={""} style={styles.level2Spacing}>
      //   <Text key={""} style={styles.dataKey}>
      //     SAI:
      //   </Text>{" "}
      //   {product?.customAttributes.SIA}
      // </Text>,
    ];

    product?.customAttributes?.forEach((customAttribute: any) => {
      htmlData = [
        ...htmlData,
        <Text key={customAttribute?.value} style={styles.level2Spacing}>
          {customAttribute.displayName} ({customAttribute.value}): {customAttribute?.color}{" "}
          {customAttribute.gradientColors.length > 0
            ? `(${customAttribute.gradientColors.join(", ")})`
            : ""}
        </Text>,
      ];
    });

    htmlData = [
      ...htmlData,
      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Data:
        </Text>
      </Text>,
    ];

    product?.designData?.forEach((design: any) => {
      htmlData = [
        ...htmlData,
        <Text key={design?.viewName} style={{ ...styles.level2Spacing, marginTop: "8px" }}>
          View Name: {design?.viewName}
        </Text>,
        <Text key={design?.layoutLocationName} style={styles.level2Spacing}>
          Layout: {design?.layoutLocationName}
        </Text>,
      ];

      design?.text?.length > 0
        ? (htmlData = [
          ...htmlData,
          <Text key={"text"} style={styles.level2Spacing}>
              Text:
          </Text>,
        ])
        : (htmlData = [...htmlData]);

      design?.text?.forEach((text: any) => {
        htmlData = [
          ...htmlData,
          <Text key={text?.locationName} style={styles.level3pacing}>
            Text Location: {text?.locationName}
          </Text>,
          <Text key={text?.text} style={styles.level3pacing}>
            Team Name: {text?.text}
          </Text>,
          <Text key={text?.fontCode} style={styles.level3pacing}>
            Font Display: {text?.fontCode}
          </Text>,
          <Text key={text?.color} style={styles.level3pacing}>
            Text Color: {text?.colorName}
          </Text>,
          <Text key={text?.strokeColorName} style={styles.level3pacing}>
            Outline 1: {text?.strokeColorName}
          </Text>,
          <Text key={text?.doubleStrokeColorName} style={styles.level3pacing}>
            Outline 2: {text?.doubleStrokeColorName}
          </Text>,
          <Text key={text?.textStyle} style={styles.level3pacing}>
            Text Style: {text?.textStyle}
          </Text>,
          <Text key={text?.fontSizeInInch} style={styles.level3pacing}>
            Text Size: {text?.fontSizeInInch} Inches
          </Text>,
        ];
      });

      design?.images?.length > 0
        ? (htmlData = [
          ...htmlData,
          <Text key={"image"} style={styles.level2Spacing}>
            Image:
          </Text>,
        ])
        : (htmlData = [...htmlData]);

      design?.images?.forEach((image: any) => {
        htmlData = [
          ...htmlData,
          <Text key={image?.clipartName} style={styles.level3pacing}>
            Image name: {image?.clipartName ? image?.clipartName : image?.imageName}
          </Text>,
          <Text key={image?.locationName} style={styles.level3pacing}>
            Image Location: {image?.locationName}
          </Text>,
        ];
      });

      htmlData = [
        ...htmlData,
        <Text
          key={"border"}
          style={{ border: "0.5px solid grey", marginTop: "8px", width: "75%" }}
        ></Text>,
      ];
    });
  });
  return htmlData;
};

export default ArtifiPdfPage;
